<template>
  <v-menu
    ref="datePickerMenu"
    v-model="datePicker"
    :close-on-content-click="false"
    :nudge-right="40"
    :return-value.sync="date"
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        v-model="formattedDate"
        :label="label"
        append-icon="event"
        v-on="on"
        @blur="resetFormattedDate"
        @keyup="datePicker = false"
      ></v-text-field>
    </template>
    <v-date-picker
      v-model="date"
      no-title
      scrollable
      @input="$refs.datePickerMenu.save(date)"
    >
    </v-date-picker>
  </v-menu>
</template>
<script>
export default {
  props: ["label", "value"],
  data() {
    return {
      date: this.value,
      datePicker: false,
      formattedDate: this.dateToFormat(this.value)
    };
  },
  methods: {
    dateFromFormat(date_str) {
      if (!date_str) return null;
      var parsed = this.$moment(date_str, "L");
      if (!parsed.isValid()) return null;
      return parsed.format("YYYY-MM-DD");
    },
    dateToFormat(date) {
      if (!date) return null;
      var parsed = this.$moment(date);
      if (!parsed.isValid()) return null;
      return parsed.format("L");
    },
    resetFormattedDate() {
      var typed_date = this.dateFromFormat(this.formattedDate);
      if (typed_date) {
        this.date = typed_date;
      } else {
        this.formattedDate = this.dateToFormat(this.date);
      }
    }
  },
  watch: {
    value: {
      handler(newVal) {
        this.date = newVal;
        this.formattedDate = this.dateToFormat(newVal);
      },
      immediate: true
    },
    date(newVal) {
      this.$emit("input", newVal);
    }
  }
};
</script>
